import { render, staticRenderFns } from "./receipt-cfg-page.vue?vue&type=template&id=23221da8&scoped=true&"
import script from "./receipt-cfg-page.vue?vue&type=script&lang=js&"
export * from "./receipt-cfg-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23221da8",
  null
  
)

export default component.exports